import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Controller from "./files/controller";
import PhotoAlbumView from "./files/photoAlbumView";
import VideoAlbumView from "./files/videoAlbumView";

function PodRouter() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
    }, []);

    return (
        <div>
            {loaded && (
                <div>
                    <Routes>
                        <Route exact path="/" element={<Controller />} />
                        <Route path="/palbum/:id/:name" element={<PhotoAlbumView />} />
                        <Route path="/valbum/:id/:name" element={<VideoAlbumView />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
